module.exports = __webpack_public_path__ + "static/app_screen_2-9fc3ec6bf1a11ac4b021e5c034474712.png";